// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"310":"42094d72599fd471","3197":"37abf918fda04ae6","3877":"fe336940f98fdfab","4450":"bbdbea4dee782a65","6272":"9da836bbf3f04e6e","7971":"5bc041620350369f"}[chunkId] + ".css";
};